/**
 * Resolve a runtime-recognised timezone (including legacy aliases) to the
 * identifier used by the server runtime. Unknown values return null.
 */
export function normalizeTimezoneId(value: string): string | null {
  if (value === "UTC") return "UTC";
  try {
    return new Intl.DateTimeFormat("en", {
      timeZone: value,
    }).resolvedOptions().timeZone;
  } catch {
    return null;
  }
}

/** True when the value is already the runtime's resolved identifier. */
export function isCanonicalTimezoneId(value: string): boolean {
  return normalizeTimezoneId(value) === value;
}

/** Keep a trip shortlist valid, ordered, unique, and separate from its default. */
export function normalizeTripTimezoneIds(
  defaultTimezone: string,
  timezoneIds: readonly string[] | null | undefined,
): string[] {
  const normalizedDefault = normalizeTimezoneId(defaultTimezone) ?? "UTC";
  const seen = new Set<string>([normalizedDefault]);
  const normalized: string[] = [];

  for (const timezoneId of timezoneIds ?? []) {
    const resolved = normalizeTimezoneId(timezoneId);
    if (!resolved || seen.has(resolved)) continue;
    seen.add(resolved);
    normalized.push(resolved);
  }

  return normalized;
}
